/**
 * Single stock-status rule for every screen (product table, product details,
 * stock list), so one product can't show different labels in different places.
 *
 * - Out of Stock: 0 or less
 * - Low Stock: at/below the product's minimum stock, or below 5 when no minimum is set
 * - In Stock: otherwise
 */
export const DEFAULT_LOW_STOCK_THRESHOLD = 5;

export type StockStatus = {
  label: 'Out of Stock' | 'Low Stock' | 'In Stock';
  color: 'error' | 'warning' | 'success';
};

export function getStockStatus(
  currentStock: number | string | null | undefined,
  minimumStock?: number | string | null,
): StockStatus {
  const stock = Number(currentStock ?? 0) || 0;
  const minimum = Number(minimumStock ?? 0) || 0;

  if (stock <= 0) return { label: 'Out of Stock', color: 'error' };
  const isLow =
    minimum > 0 ? stock <= minimum : stock < DEFAULT_LOW_STOCK_THRESHOLD;
  return isLow
    ? { label: 'Low Stock', color: 'warning' }
    : { label: 'In Stock', color: 'success' };
}
